import {
    ADD_CARDCONFIG_FAILED,
    ADD_CARDCONFIG_LOADING,
    ADD_CARDCONFIG_SUCCESS,
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
};

export const addCardConfigReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {

    switch (action.type) {
        case ADD_CARDCONFIG_LOADING:
            return {
                ...state,
                loading: action.loading,
            };
        case ADD_CARDCONFIG_SUCCESS:
            return {
                ...state,
                loading: false,
                MerchantPayment: action.payload,
                status: action.status,
                error: null,
            };
        case ADD_CARDCONFIG_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
            };
       
        default:
            return state;
    }
};




